import { Icon, cn } from '@nexa/ui';

interface BadgeRow {
  readonly kind: 'badge';
  readonly code: string;
  readonly tint: 'danger' | 'success' | 'brand';
  readonly label: string;
  readonly trailing: string;
}

interface IconRow {
  readonly kind: 'icon';
  readonly label: string;
  readonly trailing: string;
}

export interface KnowledgeFileRowProps {
  readonly row: BadgeRow | IconRow;
}

/*
 * Bảng tra CỤC BỘ trong component — đây là chỗ `as const` ĐÚNG, khác hẳn file copy (nơi nó làm
 * bản `en` không gán được vào `Copy`). Đừng gỡ nhầm cái này khi dọn `as const` ở copy.
 */
const TINT = {
  danger: 'bg-danger-bg text-danger-fg',
  success: 'bg-success-bg text-success-fg',
  brand: 'bg-brand-50 text-brand-600',
} as const;

/**
 * Một hàng trong vùng list của card `#knowledge` — `template.html:957-959` (huy hiệu) và
 * `:965-967` (icon).
 *
 * Vì sao KHÔNG dùng `MockRowList` của `packages/ui` dù docblock của nó hứa sẵn "list file của
 * `#knowledge` ở lô C": đo lại thì nó không phủ. `MockRowList` vẽ hàng thành CARD có viền, mã
 * chữ mono, nhãn đậm và đuôi mang màu TRẠNG THÁI; hàng ở đây trần, dẫn đầu bằng huy hiệu có tint
 * hoặc icon, nhãn thường, đuôi màu cố định. `MockListRow` cũng không có trường nào cho tint hay
 * icon. Một hộ dùng không đủ căn cứ chốt API dùng chung.
 *
 * Huy hiệu bo 7px (`template.html:957-959`) dùng bậc `--radius-badge`. Bản đầu của lô C mượn
 * `radius-field` (8px) vì lúc đó `tokens.css` chưa có bậc 7 — nay có, nên nợ 1px đó đã đóng.
 */
export function KnowledgeFileRow({ row }: KnowledgeFileRowProps) {
  return (
    <div className="flex items-center gap-2.5 text-body-sm text-ink-700">
      {row.kind === 'badge' ? (
        <span
          className={cn(
            'grid size-[26px] shrink-0 place-items-center rounded-badge text-nano font-extrabold',
            TINT[row.tint],
          )}
        >
          {row.code}
        </span>
      ) : (
        <Icon name="file-text" size={15} className="shrink-0 text-ink-400" />
      )}
      <span>{row.label}</span>
      <span className="ml-auto shrink-0 text-eyebrow text-ink-400">{row.trailing}</span>
    </div>
  );
}
